export default "__VITE_ASSET__83c5b9ca__"